// Display-layer coherence label mapping.
//
// Backend stores raw state names (FRAGMENTED, STABILIZING, STABLE_COHERENCE,
// REGRESSING, SAFETY_GATED). User-facing surfaces render the friendly form;
// the practitioner report and any research/admin export keep the raw value.
//
// REGRESSING and SAFETY_GATED keep their existing user-facing strings —
// REGRESSING because it carries a directional meaning the four-step ladder
// doesn't capture, and SAFETY_GATED because the state has its own dedicated
// non-directive view (SafetyGatedView) and the label rarely surfaces.
const FRIENDLY_LABELS = {
  FRAGMENTED: "Finding your rhythm",
  STABILIZING: "Building momentum",
  STABLE_COHERENCE: "In flow",
  REGRESSING: "Shifting back",
  SAFETY_GATED: "Take care first",
  CALIBRATING: "Calibrating",
};

export function coherenceLabel(rawStatus, { fallback = "" } = {}) {
  if (!rawStatus) return fallback;
  return FRIENDLY_LABELS[rawStatus] || fallback || rawStatus;
}
